module.exports = __webpack_public_path__ + "img/example.c9519c30.png";